import {PenLineIcon, Wand2Icon} from 'lucide-react';
import {Controls, ControlButton, useReactFlow, ControlButtonProps} from '@xyflow/react';
import {EdgeStyleSetButton} from './toolbar/edge-style-set';
import React from 'react';

export const MyControls = () => {
  return (
    <Controls>
      <EdgeStyleSetButton>
        <div>
          <ControlButton title="Chỉnh sửa đường nối">
            <PenLineIcon />
          </ControlButton>
        </div>
      </EdgeStyleSetButton>
    </Controls>
  );
};
